import { docketwiseRoutes } from './docketwise'
import { ecoMemberPassRoutes } from './eco-member/passes'
import { ecoMemberProfileRoutes } from './eco-member/profile'
import { ecoPortalRoutes } from './eco-portal'

export default [
  docketwiseRoutes,
  ecoMemberPassRoutes,
  ecoMemberProfileRoutes,
  ecoPortalRoutes,
]
